// Autogenerated file
export const bidItemTypesEnum = {
    Car: "Car",
    Driver: "Driver",
    Trailer: "Trailer",
    SecondaryDriver: "SecondaryDriver",
};
export const bidItemTypes = [
    { label: "Машина", value: "Car" },
    { label: "Водитель", value: "Driver" },
    { label: "Прицеп", value: "Trailer" },
    { label: "Второй водитель", value: "SecondaryDriver" },
];
